import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=316b414a&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b414a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316b414a')) {
      api.createRecord('316b414a', component.options)
    } else {
      api.reload('316b414a', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=316b414a&scoped=true&", function () {
      api.rerender('316b414a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Auth/Register/Register.vue"
export default component.exports